import * as React from 'react';
import ResizeObserver from 'resize-observer-polyfill';

type UseElementOverflowParams = {
  enabled?: boolean;
  deps?: React.DependencyList;
  ref: React.MutableRefObject<HTMLDivElement | null>;
};

const useElementOverflow = ({
  enabled = true,
  deps = [],
  ref
}: UseElementOverflowParams): {
  hasOverflow: boolean;
} => {
  const [hasOverflow, setHasOverflow] = React.useState(false);

  const handleOverflowCheck = React.useCallback(() => {
    if (!enabled || !ref.current) {
      setHasOverflow(false);
      return;
    }

    setHasOverflow(ref.current.scrollHeight > ref.current.clientHeight);
  }, [enabled]);

  React.useEffect(() => {
    if (!enabled || !ref.current) {
      return;
    }

    const observer = new ResizeObserver(handleOverflowCheck);
    observer.observe(ref.current);
    handleOverflowCheck();

    return () => {
      observer.disconnect();
    };
  }, [enabled, handleOverflowCheck, ...deps]);

  return { hasOverflow };
};

export default useElementOverflow;
